import HttpService from '../http/HttpService';
import VcomProvider from '../../VcomProvider';
import WindowProvider from '../window/WindowProvider';

export default async function downloadFile(endpoint, data = {}) {
  const response = await HttpService.post(endpoint, data);

  if (response.data.tmp_name !== undefined && response.data.name !== undefined) {
    const baseDirectory = `${VcomProvider.baseUrl}/default/file/download/get/`;
    const fileDirectory = `${response.data.tmp_name}/name/${response.data.name}/download`;
    const downloadFileLink = `${baseDirectory}${fileDirectory}`;
    WindowProvider.location.href = downloadFileLink;
  }
}
